import { useEffect } from 'react'
import { refreshAccessToken } from '@/api/refreshToken'
import { useAuthStore } from '@/stores/authStore'

const REFRESH_THRESHOLD_MS = 5 * 60 * 1000

export function useAuthBootstrap(): void {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const rememberMe = useAuthStore((state) => state.rememberMe)
  const expiresAt = useAuthStore((state) => state.expiresAt)
  const isImpersonating = useAuthStore((state) => state.isImpersonating)

  useEffect(() => {
    if (!isAuthenticated || !rememberMe || isImpersonating || !expiresAt) {
      return
    }

    const msUntilExpiry = expiresAt - Date.now()
    if (msUntilExpiry > REFRESH_THRESHOLD_MS) {
      return
    }

    void refreshAccessToken().catch(() => {
      // 401 обработает interceptor при следующем API-запросе
    })
  }, [expiresAt, isAuthenticated, isImpersonating, rememberMe])
}
